var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { filter } from 'rxjs/operators';
import { UserStore } from './user.store';
import { UserQuery } from './user.query';
var UserState = /** @class */ (function () {
    function UserState(store, query) {
        this.store = store;
        this.query = query;
    }
    UserState.prototype.getUserSnapshot = function () {
        return this.query.getUserSnapshot();
    };
    UserState.prototype.getUser = function () {
        return this.query.getUser();
    };
    UserState.prototype.isLoading = function () {
        return this.query.isLoading();
    };
    UserState.prototype.userHasPlcCard = function () {
        return this.query.userHasPlcCard();
    };
    UserState.prototype.setLoading = function (status) {
        if (status === void 0) { status = true; }
        this.store.setLoading(status);
    };
    UserState.prototype.setState = function (user) {
        this.store.update(function (state) { return (__assign({}, state, { user: user, loading: false })); });
    };
    UserState.prototype.setDateOfBirthStatus = function (status) {
        this.store.update(function (state) { return (__assign({}, state, { hasDateOfBirth: status })); });
    };
    UserState.prototype.setAgeVerifiedNegative = function (status) {
        this.store.update(function (state) { return (__assign({}, state, { ageVerifiedNegative: status })); });
    };
    UserState.prototype.hasDateOfBirth = function () {
        return this.query.select(function (state) { return state.hasDateOfBirth; })
            .pipe(filter(function (hasDateOfBirth) { return hasDateOfBirth !== null; }));
    };
    UserState.prototype.ageVerifiedNegative = function () {
        return this.query.select(function (state) { return state.ageVerifiedNegative; })
            .pipe(filter(function (ageVerifiedNegative) { return ageVerifiedNegative !== null; }));
    };
    UserState.prototype.setUserHasPlcCard = function (hasPlc) {
        var user = this.getUserSnapshot();
        user.containsPlcCard = hasPlc;
        this.setState(user);
    };
    UserState.prototype.userHasMultiplePlcAccounts = function () {
        return this.query.select(function (state) { return state.hasMultiplePlcAccounts; });
    };
    UserState.prototype.setUserHasMultiplePlcAccounts = function (hasMultipleAccounts) {
        this.store.update(function (state) { return (__assign({}, state, { hasMultiplePlcAccounts: hasMultipleAccounts })); });
    };
    UserState.prototype.userHasMultipleCardGroups = function () {
        return this.query.select(function (state) { return state.hasMultiplePlcCardGroups; });
    };
    UserState.prototype.setUserHasMultipleCardGroups = function (hasMultipleCardGroups) {
        this.store.update(function (state) { return (__assign({}, state, { hasMultiplePlcCardGroups: hasMultipleCardGroups })); });
    };
    UserState.prototype.hasMarkedMarketingConsent = function () {
        return this.query.select(function (state) { return state.hasMarkedMarketingConsent; });
    };
    UserState.prototype.setMarkedMarketingConsent = function (marked) {
        this.store.update(function (state) { return (__assign({}, state, { hasMarkedMarketingConsent: marked })); });
    };
    return UserState;
}());
export { UserState };
